// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ApiOutlinedSvg from "@fishx/icons-svg/es/asn/ApiOutlined";
import FishxIcon from '../components/FishxIcon';

var ApiOutlined = function ApiOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ApiOutlinedSvg
  }));
};

ApiOutlined.displayName = 'ApiOutlined';
export default React.forwardRef(ApiOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ApiOutlined.js
// module id = 1993
// module chunks = 0